<template>
  <div>
    <div class="block__container block__container--compact">
      <step-header-component :headerText="headerText" :subHeaderText="subHeaderTextFull"></step-header-component>
      <generic-pricing :noAveragePriceLabel="noAveragePriceLabel" :averagePercentSavingLabel="averagePercentSavingLabel"/>
      <csat :header="npsHeaderText" :tellUsMicrocopy="csatTellUsMicrocopy"></csat>
    </div>
    <div class="block--tertiary block--center">
      <div class="block__container">
        <company-details></company-details>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import {
  namespace
} from 'vuex-class';
import StepHeaderComponent from '../general/StepHeaderComponent.vue';
import ThanksTickComponent from '../ui/ThanksTickComponent.vue';
import CompanyDetailsComponent from '../general/CompanyDetailsComponent.vue';
import PricingDataComponent from '../pricing/PricingDataComponent.vue';
import GenericPricingComponent from '../pricing/GenericPricingComponent.vue';
import CustomerSatisfactionComponent from '../enquiry/CustomerSatisfactionComponent.vue';

const VehicleModule = namespace('vehicleModule');

@Component({
  components: {
  'step-header-component': StepHeaderComponent,
  'thanks-tick': ThanksTickComponent,
  'company-details': CompanyDetailsComponent,
  'pricing-data': PricingDataComponent,
  'generic-pricing': GenericPricingComponent,
  csat: CustomerSatisfactionComponent
  }
  })

export default class ThanksStepComponent extends Vue {
  @VehicleModule.Getter public averagePriceAvailable;

  @VehicleModule.Getter public currentDerivative;

  @Prop({ default: 'Thanks for your enquiry' })
  public headerText!: string;

  @Prop({ default: 'We will be in touch to talk more about your future vehicle.' })
  public subHeaderText!: string;

  @Prop({ default: 'This is for feedback only. If you change your mind at any time, <a title="Contact us" href="mailto:datacontroller@askaprice.com">contact us</a>' })
  public csatTellUsMicrocopy!: string;

  @Prop({ default: 'How would you <span> rate your overall satisfaction </span> with the service you received today?' })
  public npsHeaderText!: string;

  @Prop({ default: 'We don\'t currently have any discount price data for the exact vehicle you\'ve selected, however we are typically seeing <span>discounts of up to averagePercent on vehicleName cars.</span>  We\'ll now work to get you a great quote.' })
  public averagePercentSavingLabel!: string;

  @Prop({ default: 'We don\'t have specific discount prices for this specific car right now but can help you get an accurate quotation from a local dealership. We’ll ensure someone contacts you shortly to help' })
  public noAveragePriceLabel!: string;

  public get subHeaderTextFull(): string {
    return this.averagePriceAvailable ? `${this.subHeaderText} In the meantime here is your pricing data.` : this.subHeaderText;
  }

  public get enquiryDerivative() {
    return this.currentDerivative;
  }
}
</script>
